import { render } from "./edi-settings.vue?vue&type=template&id=5f38289a&scoped=true"
import script from "./edi-settings.vue?vue&type=script&lang=js"
export * from "./edi-settings.vue?vue&type=script&lang=js"

import "./edi-settings.vue?vue&type=style&index=0&id=5f38289a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f38289a"]])

export default __exports__